module.exports = __webpack_public_path__ + "img/bg04.111f9c2e.png";